import {
  getFocusedRouteNameFromRoute,
  useRoute,
} from '@react-navigation/native';

export const useActiveRouteName = () => {
  const route = useSafeRoute();

  if (!route) return '';

  const routeName = getFocusedRouteNameFromRoute(route) ?? route.name; // support both top level and nested routes

  return routeName;
};

// ─────────────────────────────────────────────────────────────────────────────

function useSafeRoute() {
  try {
    return useRoute();
  } catch {
    return null;
  }
}
